import * as React from 'react';
import { Check } from 'lucide-react';

import { cn } from '../../lib/cn';

// The five-night capture strip: filled tick for a night that recorded, hollow for
// one that did not, fading toward the oldest.
export const CaptureStepper = React.forwardRef(({ className, nights = [], ...props }, ref) => {
  // The design fades each successive missed night by 0.1, starting at 0.6.
  let missed = -1;
  return (
    <div ref={ref} className={cn('flex items-center gap-2', className)} {...props}>
      {nights.map((night) => {
        if (!night.captured) missed += 1;
        return (
          <div
            key={night.day}
            className="flex flex-col items-center gap-2"
            style={{ opacity: night.captured ? 1 : Math.max(0.2, 0.6 - missed * 0.1) }}
          >
            <span
              className={cn(
                'flex h-6 w-6 items-center justify-center rounded-full border',
                night.captured
                  ? 'border-dusq-emphasis-high bg-transparent text-dusq-emphasis-high'
                  : 'border-dusq-grey600 text-dusq-grey600'
              )}
            >
              <Check className="h-3.5 w-3.5" />
            </span>
            <span className="font-display text-[10px] font-semibold text-dusq-grey5">
              {night.day}
            </span>
          </div>
        );
      })}
    </div>
  );
});
CaptureStepper.displayName = 'CaptureStepper';
